/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { TEST_DATA, FilterData } from "./test-data/sports.assets";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ASSETS } from "../pages/Collectibles/graphql/getassets.query";

import { VApplication } from "../application";
const is = require("is_js");
const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "traffic-light.service";
const log: any = LoggerModule.getInstance();

export class SportsAssetService {
    name = SERVICE_NAME;
    private static instance: SportsAssetService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new SportsAssetService();
        }
        return this.instance;
    }
    async init() {}

    async getAssets(size: number, offset: number) {
        log.info(`inside getAssets Service`);
        // const graphqlModule = getGraphQLModule();
        // const client = graphqlModule.getClient("api-gateway");
        // try {
        //     if (client) {
        //         const res = await client.query({
        //             query: GET_ASSETS,
        //             variables: {
        //                 size: size,
        //                 offset: offset,
        //                 filter:{
        //                     state:"listed",
        //                     store:"61739cbd2fbe0a187c984fb6",
        //                     category:"sports"
        //                 }
        //             },
        //             fetchPolicy: 'network-only'
        //         });
        //         log.success(SERVICE_NAME, "get assets result: ", res);
        //         return {
        //     pagination: {
        //         nextOffset: offset + res?.data?.getAssets?.pageSize,
        //         totalItems: res?.data?.getAssets?.length,
        //     },
        //     results: res?.data?.getAssets?.data,
        // }
        //     }
        // } catch (err) {
        //     log.error(SERVICE_NAME, "error in get assets", err);
        //     // throw Error(`${err?.message}`)
        //     return {
        //         pagination: {
        //             nextOffset: 0,
        //             totalItems: 0,
        //         },
        //         results: [],
        //     };
        // }
        let _found = TEST_DATA;
        let _data =
            is.array(_found) &&
            _found.map((item) => {
                return {
                    ...item,
                    scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1",
                };
            });
        _data = _data.slice(offset, offset + size);

        return {
            pagination: {
                nextOffset: offset + _found.length,
                totalItems: TEST_DATA?.length,
            },
            results: _data,
        };
    }

    async getFilterData() {
        let _filterData = FilterData;
        return _filterData;
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
